import { render } from "./OrderDetails.vue?vue&type=template&id=3b722def&scoped=true"
import script from "./OrderDetails.vue?vue&type=script&lang=js"
export * from "./OrderDetails.vue?vue&type=script&lang=js"

import "./OrderDetails.vue?vue&type=style&index=0&id=3b722def&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b722def"]])

export default __exports__